import styled from '@emotion/styled';
import { colorToAlpha } from 'helpers/insight';
import { Text } from 'ds/components/typography';

export const Root = styled.div(({ theme }) => ({
  position: 'fixed',
  display: 'flex',
  flexDirection: 'column',
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  zIndex: 1111,
  backgroundColor: colorToAlpha(theme.colors.neutrals.black, 0.9),
  '& .view-pager-rail': {
    display: 'flex',
  },
}));

export const Header = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(3.5, 5),
}));

export const Footer = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: theme.colors.neutrals.white,
  minHeight: '96px',
}));


export const BackBtn = styled.div(({ theme }) => ({
  cursor: 'pointer',
  minWidth: '142px',
  '> svg': {
    'path': {
      fill: theme.colors.neutrals.white,
    },
  },
}));

export const ExtraBtnWrapper = styled.div(({ theme }) => ({
  padding: `0 ${theme.spacing(3)}`,
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  '[data-auto="share-button"]': {
    backgroundColor: theme.colors.neutrals.black,
    borderColor: theme.colors.neutrals.grey3,
    'svg path': {
      fill: theme.colors.neutrals.white,
    },
  },
  '[data-auto="bulletin-favorite-button"]': {
    backgroundColor: theme.colors.neutrals.black,
    borderColor: theme.colors.neutrals.grey3,
    'svg path': {
      fill: theme.colors.neutrals.black,
      stroke: theme.colors.neutrals.white,
    },
  },
  '[data-auto="bulletin-favorite-button"][data-auto-active="true"]': {
    'svg path': {
      stroke: '#FF6658',
      fill: '#FF6658',
    },
  },
}));

export const SliderPager = styled.div({
  position: 'relative',
  overflow: 'hidden',
  display: 'flex',
  alignItems: 'center',
  '> div': {
    height: '100%',
  },
});

export const SliderPagerBody = styled.div(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  flexGrow: 1,
  paddingBottom: theme.spacing(1),
  height: 'calc(100vh - 95px - 96px)',
}));

export const SliderPagerControl = styled.div<{ disabled: boolean }>(({ theme, disabled }) => ({
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  paddingLeft: theme.spacing(4),
  paddingRight: theme.spacing(3),
  '&[dir="next"]': {
    svg: {
      transform: 'rotate(180deg)',
    },
  },
  ...(disabled ? {
    'svg path': {
      fill: '#7E7C7C',
    },
  } : {}),
}));

export const PageInfo = styled(Text)(({ theme }) => ({
  color: theme.colors.neutrals.white,
}));
